<template>
	<CRow>
		<CCol>
			<h4 class="my-4">
				FFD
			</h4>
			<CRow>
				<CCol lg="6">
					<div class="form-group">
						<p class="label">
							FFD Price
						</p>
						<BaseInputNumber
							:value="priceFfd"
							:decimal-scale="2"
							prepend-text="฿"
							disabled
						/>
					</div>
				</CCol>
			</CRow>
			<hr class="mt-4">
		</CCol>
	</CRow>
</template>

<script>
export default {
	name: 'ProductEditFFD',
	props: {
		priceFfd: {
			type: String,
			default: null,
		},
	},
};
</script>
